// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import sensors from 'sa-sdk-javascript'

// 神策 SDK 补充类型声明（sa-sdk-javascript 无官方 @types）
declare const sensors: {
  init(config: Record<string, unknown>): void
  quick(type: string): void
  track(event: string, properties?: Record<string, unknown>): void
  login(userId: string): void
}

export function initSensors() {
  const isProduction = import.meta.env.VITE_DEPLOY_ENV === 'pr'
  sensors.init({
    server_url: isProduction
      ? 'https://dts-log.anker.com/sa?project=production'
      : 'https://dts-log.anker.com/sa?project=default&debug=true',
    is_track_single_page: true,
    use_client_time: true,
    send_type: 'beacon',
    show_log: !isProduction,
    heatmap: {
      clickmap: 'default',
      scroll_notice_map: 'not_collect',
    },
  })
  sensors.quick('autoTrack')
}

export { sensors }
